
<style lang="scss" scoped>
@import "src/assets/scss/indah";

.dataview {
  font-family: "Inter", sans-serif;
  & .table {
    border: none;
    & tr:first-child td,
    & tr:first-child th {
      border-top: none;
    }

    & tr td:first-child,
    & tr th:first-child {
      border-left: none;
    }

    & tr td:last-child,
    & tr th:last-child {
      border-right: none;
    }
    &-responsive {
      border: 1px solid #bdbdbd !important;
      box-shadow: 0 5px 10px rgba(154, 160, 185, 0.05);
      &::-webkit-scrollbar-thumb {
        background: #bdbdbd;
      }
    }
  }
  & thead {
    background-color: #e0e0e0;
    color: #616161;
  }
  & th,
  & td {
    border: 1px solid #bdbdbd;
  }
  & th {
    font-weight: 600;
    border-bottom: 1px solid #c9c6c6 !important;
    text-transform: capitalize;
    min-width: 100px;
  }
  & td {
    color: #616161;
  }
  & legend {
    color: #00796b !important;
    border-bottom: 1px solid #bccecc;
    font-weight: 700;
    text-transform: capitalize;
    margin-bottom: 10px !important;
  }
  & .dropdown-menu {
    min-width: 107px !important;
  }
}
</style>

<style lang="scss" scoped>
.wrapper {
  margin-top: 14px;
  padding: 0;
}
.nav-tabs {
  display: flex;
}
.button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 32px;
  min-width: 80px;
  border: 1px solid #c9c6c6;
  background-color: transparent;
  border-radius: 4px;
  z-index: 99;

  &-group .button {
    border-radius: 0px;
    &:first-child {
      border-radius: 4px 0 0 4px;
    }
    &:last-child {
      border-radius: 0 4px 4px 0;
    }
  }

  &-warning {
    border: 1px solid #ffd900;
    background-color: #ffd900;
    color: rgb(80, 80, 80) !important;
    font-weight: 600;
  }
  &-primary {
    border: 1px solid rgb(21, 70, 143) !important;
    background-color: rgb(21, 70, 143) !important;
    color: white !important;
    font-weight: 600;
  }
  &-reset {
    border: 1px solid #9e9e9e;
    background-color: #e0e0e0;
    color: rgb(80, 80, 80);
  }
  &:hover {
    opacity: 0.95;
  }
}
.title {
  font-size: 26px;
  margin: 0;
  line-height: 1.2;
  color: rgb(0 43 106);
  font-weight: 600;
  &-info {
    font-size: 15px;
    font-weight: 500;
    color: #757575;
  }
}
.tabs {
  &-nav {
    display: flex;
  }
  &-button {
    min-height: 40px;
    min-width: 100px;
    background-color: transparent;
    color: rgb(0, 43, 106);
    border: 1px solid rgb(0, 43, 106);
    font-weight: 600;
    &.active {
      color: #ffffff !important;
      background-color: rgb(21, 70, 143) !important;
      font-weight: 500;
    }
  }
}
select {
  color: #616161;
  font-weight: 600;
  text-transform: uppercase;
  box-shadow: none !important;
}
</style>
<template>
  <div class="dataview">
    <div
      class="border-bottom"
      style="position: sticky; top: 46px; z-index: 100"
    ></div>
    <b-container
      class="wrapper wrapper-main"
      fluid
      v-if="!isLoading"
      style="background-color: #fafafa"
    >
      <div class="" style="padding: 30px 60px 100px 60px">
        <div class="title" id="tabel-choosen-dataset-title">
          {{ title }}
        </div>

        <div class="d-flex align-items-center mt-2">
          <div class="title-info border-right pr-2">
            Produsen : <b>{{ metadata.owner }}</b>
          </div>

          <div class="title-info border-right px-2">
            Data tersedia hingga level : <b>{{ regionLevel }}</b>
          </div>
          <div class="title-info px-2">
            Periode : <b>{{ periods.join(", ") }}</b>
          </div>
        </div>
        <div class="d-flex" style="margin-top: 30px">
          <div v-if="filterDimensions.length > 0" class="mr-2">
            <button
              :class="filterVisible ? 'button button-warning ' : 'button'"
              @click="filterVisible = !filterVisible"
              style="height: 40px"
            >
              <VueFeather
                type="filter"
                size="16"
                stroke-width="1.5"
              ></VueFeather
              >&nbsp; Filter
            </button>
            <!-- <b-dropdown
              class="button button-primary ml-1"
              style="
                border-radius: 4px;
                margin-top: -8px;
                height: 40px;
                /* background-color: rgb(0 43 106) !important; */
                /* color: white !important; */
              "
            >
              <template #button-content>
                <div class="d-flex align-items-center">
                  <VueFeather
                    type="download"
                    size="16"
                    stroke-width="2.2"
                  ></VueFeather
                  >&nbsp; Download
                </div>
              </template>
              <b-dropdown-item @click="downloadCSV">CSV</b-dropdown-item>
              <b-dropdown-item @click="downloadExcel">Excel</b-dropdown-item>
              <b-dropdown-item href="#">PDF</b-dropdown-item>
              <b-dropdown-item href="#">Json</b-dropdown-item>
              <b-dropdown-item href="#">XML</b-dropdown-item>
            </b-dropdown> -->
          </div>
          <div class="tabs-nav">
            <div class="d-flex button-group">
              <button
                v-for="(tab, index) in tabs"
                :key="index"
                :class="
                  index == tabIndex
                    ? 'button tabs-button active'
                    : 'button tabs-button'
                "
                @click="tabIndex = index"
              >
                <VueFeather
                  :type="tab.icon"
                  size="16"
                  stroke-width="2"
                ></VueFeather
                >&nbsp;
                {{ tab.name }}
              </button>
            </div>
          </div>
          <div class="ml-auto d-flex align-items-center">
            <div
              style="
                font-weight: 600;
                color: rgb(0, 43, 106);
                white-space: nowrap;
              "
              class="mr-2"
            >
              Wilayah :
            </div>
            <b-form-select
              class="mr-2"
              v-model="selectedRegionId"
              :options="filterRegions"
              size="sm"
              required
              @change="getDetailDatasetWithRegionFilter"
            >
            </b-form-select>
            <button class="button button-reset" @click="resetDataview">
              <VueFeather type="x" size="16" stroke-width="1.5"></VueFeather
              >&nbsp; Reset
            </button>
          </div>
        </div>
      </div>
      <div style="margin-top: -95px; padding: 0px 60px 100px 60px">
        <b-tabs v-model="tabIndex" content-class="mt-1 pt-2" nav-class="d-none">
          <b-tab active class="i-nav-tabs">
            <b-row>
              <b-col
                cols="3"
                class="pl-0"
                v-show="filterVisible"
                v-if="filterDimensions.length > 0"
              >
                <div class="empty-card px-4 py-3">
                  <b-form-group
                    v-for="dim in filterDimensions"
                    :key="dim.name"
                    :label="dim.name"
                  >
                    <b-form-checkbox
                      v-for="item in dim.items"
                      :key="item.value"
                      v-model="selectedDimensionItems"
                      :value="item.value"
                    >
                      {{ item.text }}
                    </b-form-checkbox>
                  </b-form-group>
                </div>
              </b-col>
              <b-col
                :cols="
                  filterVisible && filterDimensions.length > 0 ? '9' : '12'
                "
                :class="
                  filterVisible && filterDimensions.length > 0 ? 'pr-0' : 'px-0'
                "
              >
                <div class="table-responsive">
                  <b-table
                    id="tabel-dinamis-pivot-table"
                    class="table"
                    ref="dataTable"
                    bordered
                    hover
                    show-empty
                    :fields="fields"
                    :items="transformData4"
                    :tbody-tr-class="rowClass"
                    thead-class="table-thead"
                  >
                    <template #empty="scope">
                      <div style="text-align=center">{{ scope.emptyText }}</div>
                    </template>

                    <template #thead-top>
                      <b-tr
                        v-for="(field, index) in additionalFields"
                        :key="index"
                      >
                        <b-th
                          style="border-bottom: 0 !important"
                          v-if="index == 0"
                          :colspan="
                            regions[0].items.length > 1
                              ? row_dimensions.length + regions.length
                              : row_dimensions.length > 1
                              ? row_dimensions.length
                              : 1
                          "
                          :rowspan="
                            col_dimensions.length > 1
                              ? col_dimensions.length - 1
                              : 1
                          "
                        ></b-th>
                        <th
                          class="additional-fields"
                          v-for="item in field.items"
                          :key="item.id"
                          :ref="item.id.toString()"
                          :id="item.id"
                          :colspan="col_number / field.items.length"
                        >
                          {{ item.label }}
                        </th>
                      </b-tr>
                    </template>

                    <template #head()="data">
                      <div class="text-center">{{ data.field.label }}</div>
                      <div class="text-center">
                        <b-icon
                          :id="`column-${data.field.id}`"
                          class="light-grey"
                          icon="question-circle"
                        ></b-icon>
                      </div>
                    </template>
                  </b-table>
                </div>
              </b-col>
            </b-row>
          </b-tab>
          <b-tab class="i-nav-tabs">
            <b-row>
              <b-col class="px-0">
                <div class="empty-card">
                  <div
                    style="
                      border-bottom: 1px solid #e1e1e1;
                      background-color: #ecfafa;
                      padding: 10px 15px;
                    "
                  >
                    <span style="color: #008c8c; font-size: 15px">
                      <b-icon icon="grid-fill"></b-icon>
                    </span>
                    <label class="empty-card-title">Detail dataset</label>
                  </div>
                  <div style="margin: 20px 0 40px 0">
                    <text-view label="Nama" :value="metadata.name"></text-view>
                    <text-view
                      label="Deskripsi"
                      :value="metadata.description ? metadata.description : '-'"
                    ></text-view>
                    <text-view label="Jenis" :value="metadata.type"></text-view>
                    <text-view
                      label="Frekuensi"
                      :value="metadata.frequency"
                    ></text-view>
                    <text-view
                      label="Subyek"
                      :value="metadata.subject_field"
                    ></text-view>
                    <text-view
                      label="Periode"
                      :value="periods.join(', ')"
                    ></text-view>
                    <text-view
                      label="Level penyajian data"
                      :value="regionLevel ? regionLevel : '-'"
                    ></text-view>
                    <text-view
                      label="Produsen data"
                      :value="metadata.owner"
                    ></text-view>
                    <text-view
                      label="unit pengelola data"
                      :value="metadata.maintainer ? metadata.maintainer : '-'"
                    ></text-view>
                  </div>
                </div>
                <div class="empty-card mt-3 mb-3">
                  <div
                    style="
                      border-bottom: 1px solid #e1e1e1;
                      background-color: #e1f5fe;
                      padding: 10px 15px;
                    "
                  >
                    <span style="color: #01579b; font-size: 15px">
                      <b-icon icon="grid1x2-fill"></b-icon>
                    </span>
                    <label class="empty-card-title" style="color: #01579b"
                      >Columns</label
                    >
                  </div>
                  <div style="margin: 0px 0 40px 0; padding: 20px 32px">
                    <b-tabs
                      pills
                      vertical
                      active-nav-item-class="i-active-tab"
                      nav-class="py-1"
                      content-class="border-left pl-4"
                      nav-wrapper-class="w-25"
                    >
                      <b-tab
                        title-link-class="i-non-active-tab"
                        :title="column.column_name"
                        v-for="(column, idx) in dimensions"
                        :key="idx"
                      >
                        <b-card-text>
                          <div style="margin-bottom: 40px">
                            <div style="padding: 10px 15px">
                              <span style="color: #01579b; font-size: 15px">
                                <b-icon icon="grid-fill"></b-icon>
                              </span>
                              <label
                                class="empty-card-title"
                                style="color: #01579b"
                                >Detail Kolom</label
                              >
                            </div>
                            <div style="margin: 10px 0 20px 0">
                              <text-view
                                label="nama kolom"
                                :value="column.column_name"
                              ></text-view>
                              <text-view
                                label="alias"
                                :value="
                                  column.alternative_column_name
                                    ? column.alternative_column_name
                                    : '-'
                                "
                              ></text-view>
                            </div>
                          </div>

                          <div
                            v-for="(
                              dim, idx
                            ) in metadata.dataset_dimension.filter(
                              (x) => x.data_structure_id == column.id
                            )"
                            :key="idx"
                          >
                            <div style="padding: 10px 15px 0 15px">
                              <span style="color: #01579b; font-size: 15px">
                                <b-icon icon="code"></b-icon>
                              </span>
                              <label
                                class="empty-card-title"
                                style="color: #01579b"
                                >Klasifikasi</label
                              >
                            </div>
                            <div
                              style="0;padding-left:47px;color:#9E9E9E;font-size:13px"
                            >
                              <span
                                >Klasifikasi adalah sumber referensi yang
                                digunakan sebagai value domain dari dimensi
                                kolom pada tabel</span
                              >
                            </div>
                            <div style="margin: 20px 0 20px 0">
                              <text-view
                                label="versi klasifikasi"
                                :value="
                                  dim.dimension_classification_references[0]
                                    .classification_version
                                "
                              ></text-view>
                            </div>
                            <div style="padding: 10px 15px 0 33px">
                              <label
                                class="empty-card-title"
                                style="color: #01579b"
                                >Item Klasifikasi yang digunakan</label
                              >
                            </div>
                            <div
                              style="
                                margin: 5px 0 20px 0;
                                padding: 10px 15px 0 47px;
                              "
                            >
                              <b-table
                                bordered
                                hover
                                responsive
                                show-empty
                                :fields="[
                                  {
                                    key: 'kode',
                                    tdClass: 'text-center',
                                    thClass: 'th-min-width',
                                  },
                                  { key: 'nama', thClass: 'text-left' },
                                  { key: 'deskripsi', thClass: 'text-left' },
                                ]"
                                :items="
                                  dim.dimension_classification_items.map(
                                    (item) => ({
                                      kode: item.code,
                                      nama: item.name,
                                      deskripsi: item.description,
                                    })
                                  )
                                "
                              >
                              </b-table>
                            </div>
                          </div>
                        </b-card-text>
                      </b-tab>
                    </b-tabs>
                  </div>
                </div>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <div class="empty-card mb-3">
                  <div
                    style="
                      border-bottom: 1px solid #e1e1e1;
                      background-color: #e1f5fe;
                      padding: 10px 15px;
                    "
                  >
                    <span style="color: #01579b; font-size: 15px">
                      <b-icon icon="app-indicator"></b-icon>
                    </span>
                    <label class="empty-card-title" style="color: #01579b"
                      >Indikator Statistik</label
                    >
                  </div>
                  <div style="margin: 0px 0 40px 0; padding: 20px 32px">
                    <div
                      v-for="measure in metadata.dataset_measure"
                      :key="measure.id"
                    >
                      <div style="margin-bottom: 40px">
                        <div style="padding: 10px 15px">
                          <span style="color: #01579b; font-size: 15px">
                            <b-icon icon="bar-chart-fill"></b-icon>
                          </span>
                          <label
                            class="empty-card-title"
                            style="color: #01579b"
                            >{{ measure.statistical_indicator[0].name }}</label
                          >
                        </div>
                        <div style="margin: 10px 0 20px 0">
                          <text-view
                            label="kode"
                            :value="
                              measure.statistical_indicator[0].code
                                ? measure.statistical_indicator[0].code
                                : '-'
                            "
                          ></text-view>
                          <text-view
                            label="definisi"
                            :value="
                              measure.statistical_indicator[0].definition
                                ? measure.statistical_indicator[0].definition
                                : '-'
                            "
                          ></text-view>
                          <concept-text-view
                            label="konsep"
                            :data="
                              measure.statistical_indicator[0].concept
                                ? measure.statistical_indicator[0].concept
                                : []
                            "
                          ></concept-text-view>
                          <text-view
                            label="ukuran"
                            :value="
                              measure.statistical_indicator[0].measurement
                                ? measure.statistical_indicator[0].measurement
                                : '-'
                            "
                          ></text-view>
                          <text-view
                            label="satuan"
                            :value="
                              measure.statistical_indicator[0].measurement_unit
                                ? measure.statistical_indicator[0]
                                    .measurement_unit
                                : '-'
                            "
                          ></text-view>
                          <text-view
                            label="subyek"
                            :value="
                              measure.statistical_indicator[0].subject_field
                                ? measure.statistical_indicator[0].subject_field
                                : '-'
                            "
                          ></text-view>
                          <!-- <text-view label="level penyajian data" :value="measure.statistical_indicator[0].presentation_level ? measure.statistical_indicator[0].presentation_level : '-'"></text-view> -->
                          <text-view
                            label="manfaat"
                            :value="
                              measure.statistical_indicator[0].benefit
                                ? measure.statistical_indicator[0].benefit
                                : '-'
                            "
                          ></text-view>
                          <text-view
                            label="interpretasi"
                            :value="
                              measure.statistical_indicator[0].interpretation
                                ? measure.statistical_indicator[0]
                                    .interpretation
                                : '-'
                            "
                          ></text-view>
                          <formula-text-view
                            label="rumus"
                            :value="
                              measure.statistical_indicator[0].formula
                                ? measure.statistical_indicator[0].formula
                                : '-'
                            "
                            :formulaStructure="
                              measure.statistical_indicator[0].formula_structure
                                ? measure.statistical_indicator[0]
                                    .formula_structure
                                : []
                            "
                          ></formula-text-view>
                          <text-view
                            label="mekanisme perhitungan"
                            :value="
                              measure.statistical_indicator[0]
                                .calculation_mechanism
                                ? measure.statistical_indicator[0]
                                    .calculation_mechanism
                                : '-'
                            "
                          ></text-view>
                          <text-view
                            label="penanggung jawab indikator"
                            :value="
                              measure.statistical_indicator[0]
                                .responsible_organization
                                ? measure.statistical_indicator[0]
                                    .responsible_organization
                                : '-'
                            "
                          ></text-view>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </b-col>
            </b-row>
          </b-tab>
        </b-tabs>
      </div>
    </b-container>
    <b-container
      class="d-flex justify-content-center align-items-center"
      style="font-size: 24px; color: #01579b; min-height: 100vh"
      v-else
    >
      <div>
        <div class="text-center">
          <b-spinner variant="warning" style="font-size: 14px"></b-spinner>
        </div>
        <div style="font-size: 20px; color: rgb(0, 43, 106)">
          Menyiapkan data
        </div>
      </div>
    </b-container>
  </div>
</template>
<script>
import lodash from "lodash";
//import dataSource from "../../assets/data/data_4.json";
//import metaSource from "../../assets/data/metadata_4.json";
import "@/assets/css/dataview.css";
// import "@/assets/scss/indah.scss";
import mmsService from "../../services/MmsService";
import TextView from "../../components/TextView";
import MultiValueTextView from "../../components/MultiValueTextView";
import FormulaTextView from "../../components/FormulaTextView";
import VueFeather from "vue-feather";
// import * as XLSX from "xlsx";

export default {
  components: {
    "text-view": TextView,
    "concept-text-view": MultiValueTextView,
    "formula-text-view": FormulaTextView,
    VueFeather,
  },
  data() {
    return {
      breadcrumbs: [
        {
          text: "Beranda",
          to: "/sshi",
        },
        {
          text: "Katalog Data",
          to: "/sshi/katalog-data",
        },
        {
          text: "Detail Data",
          active: true,
        },
      ],
      id: null,
      filterVisible: true,
      isLoading: true,
      title: "",
      subtitle:
        "Merupakan mikrodata yang terdiri dari berbagai variabel yang diperoleh dari pemutakhiran data perkembangan desa pada tahun 2020",
      subject_field: "",
      data: [],
      transformData: [],
      transformData2: [],
      transformData3: [],
      transformData4: [],
      transformMeta: [],
      transformMeta2: [],
      transformMeta3: [],
      transformMeta4: [],
      metadata: [],
      periods: [],
      measures: [],

      //region
      regions: [],
      parentRegion: {},
      regionLevel: null,
      regionDataStructureId: 0,
      selectedRegionId: null,
      prevSelectedRegionId: null,
      filterRegions: [],

      //dimensions
      dimensions: [],
      row_dimensions: [],
      col_dimensions: [],
      col_number: 0,

      filterDimensions: [],
      selectedDimensionItems: [],
      unSelectedDimensionItems: [],
      tabs: [
        {
          name: "Data",
          icon: "layout",
        },
        {
          name: "Metadata",
          icon: "code",
        },
      ],
      tabIndex: 0,
      fields: [],
      additionalFields: [],
      duplicateFields: [],

      selectedFields: [],
      unSelectedFields: [],

      selectedAdditionalFields: [],
      unSelectedAdditionalFields: [],
    };
  },
  mounted() {
    this.getDetailDataset(this.$route.params.id);

    //this.setHeaderTable(metaSource);
    //this.setData(dataSource);
  },
  watch: {
    selectedDimensionItems: function (selectedValues) {
      if (this.periods.length == 1) {
        if (this.additionalFields.length == 0) {
          this.selectedFields = this.fields.filter((field) => {
            let keys = field.key.split("-");
            if (selectedValues.includes(keys[keys.length - 1])) {
              return field;
            }
          });
        }

        if (this.additionalFields.length == 1) {
          this.selectedFields = this.fields.filter((field) => {
            let keys = field.key.split("-");
            if (selectedValues.includes(keys[keys.length - 2])) {
              return field;
            }
          });
          this.selectedFields = this.selectedFields.filter((field) => {
            let keys = field.key.split("-");
            if (selectedValues.includes(keys[keys.length - 1])) {
              return field;
            }
          });
        }

        if (this.additionalFields.length == 2) {
          this.selectedFields = this.fields.filter((field) => {
            let keys = field.key.split("-");
            if (selectedValues.includes(keys[keys.length - 3])) {
              return field;
            }
          });
          this.selectedFields = this.selectedFields.filter((field) => {
            let keys = field.key.split("-");
            if (selectedValues.includes(keys[keys.length - 2])) {
              return field;
            }
          });
          this.selectedFields = this.selectedFields.filter((field) => {
            let keys = field.key.split("-");
            if (selectedValues.includes(keys[keys.length - 1])) {
              return field;
            }
          });
        }
      } else {
        if (this.additionalFields.length == 0) {
          this.selectedFields = this.fields.filter((field) => {
            let keys = field.key.split("-");
            if (selectedValues.includes(keys[0])) {
              return field;
            }
          });
        }
        if (this.additionalFields.length == 1) {
          //only period and indicator
          if (this.col_dimensions.length == 0) {
            this.selectedFields = this.fields.filter((field) => {
              let keys = field.key.split("-");
              if (selectedValues.includes(keys[0])) {
                return field;
              }
            });
          } else {
            //period and single column dimension
            this.selectedFields = this.fields.filter((field) => {
              let keys = field.key.split("-");
              if (selectedValues.includes(keys[0])) {
                return field;
              }
            });
            this.selectedFields = this.selectedFields.filter((field) => {
              let keys = field.key.split("-");
              if (selectedValues.includes(keys[keys.length - 1])) {
                return field;
              }
            });
          }
        }
      }
      this.unSelectedFields = [];
      let selectedFieldsKey = this.selectedFields.map((x) => x.key);
      this.fields.forEach((field) => {
        if (!selectedFieldsKey.includes(field.key)) {
          this.unSelectedFields.push(field);
        }
      });
      this.selectedFields.forEach((field) => {
        field.class = "d-table-cell";
      });
      this.unSelectedFields.forEach((field) => {
        if (
          field.key == "region" ||
          field.key.substr(0, field.key.length - 2) == "row_dimension" ||
          this.col_dimensions.length == 0
        ) {
          field.class = "d-table-cell";
        } else {
          field.class = "d-none";
        }
      });
      //get selected additional fields
      let additionalFields = this.additionalFields.flatMap((field, index) =>
        field.items.map((item) => ({ ...item, index: index }))
      );
      let selectedAdditionalFieldsFilter = [];
      if (this.additionalFields.length == 2) {
        additionalFields.forEach((field) => {
          if (selectedValues.includes(field.key)) {
            selectedAdditionalFieldsFilter.push(field);
          }
        });
        additionalFields.forEach((field) => {
          let keys = field.key.split("-");
          if (
            selectedValues.includes(keys[keys.length - 1]) &&
            selectedAdditionalFieldsFilter
              .flatMap((x) => x.key)
              .includes(keys[keys.length - 2])
          ) {
            selectedAdditionalFieldsFilter.push(field);
          }
        });
      }
      if (this.additionalFields.length == 1) {
        additionalFields.forEach((field) => {
          if (selectedValues.includes(field.key)) {
            selectedAdditionalFieldsFilter.push(field);
          }
        });
      }

      this.selectedAdditionalFields = selectedAdditionalFieldsFilter;
      let unSelectedAdditionalFieldsFilter = [];
      let selectedAdditionalFieldsKey = this.selectedAdditionalFields.map(
        (x) => x.key
      );

      additionalFields.forEach((field) => {
        if (!selectedAdditionalFieldsKey.includes(field.key)) {
          unSelectedAdditionalFieldsFilter.push(field);
        }
      });
      this.unSelectedAdditionalFields = unSelectedAdditionalFieldsFilter;
      this.unSelectedAdditionalFields.forEach((field) => {
        this.$refs[field.key].forEach((el) => {
          el.style.display = "none";
        });
      });

      this.selectedAdditionalFields = this.selectedAdditionalFields.reduce(
        (accumulator, field) => {
          if (!accumulator[field.index]) {
            accumulator[field.index] = [];
          }
          accumulator[field.index].push(field);
          return accumulator;
        },
        []
      );

      this.selectedAdditionalFields.forEach((field) => {
        field.forEach((item) => {
          this.$nextTick(() => {
            this.$refs[item.key].forEach((el) => {
              el.style.display = "table-cell";
              let colspan = this.selectedFields.length / field.length;
              if (colspan != 0) {
                el.colSpan = colspan;
              } else {
                el.style.display = "none";
              }
            });
          });
        });
      });
    },
  },
  methods: {
    base64: function (s) {
      return window.btoa(
        unescape(encodeURIComponent(s)) || decodeURI(encodeURIComponent(s))
      );
    },
    format: function (s, c) {
      return s.replace(/{(\w+)}/g, function (m, p) {
        return c[p];
      });
    },
    generateDataSheet() {
      // let title, table, info, temp;

      // title = document.getElementById("tabel-choosen-dataset-title").outerHTML;

      let table = document
        .getElementById("tabel-dinamis-pivot-table")
        .outerHTML.replace("b-table-sticky-header", "")
        .replace('style="position: sticky; top: 0px; z-index: 3;"', "");

      // info = document.getElementById(
      //   "tabel-dinamis-choosen-dataset-info"
      // ).outerHTML;

      let temp = document.createElement("temp");
      temp.innerHTML = table;

      temp
        .querySelectorAll("#tabel-dinamis-pivot-table > thead > tr")
        .forEach((tr) => {
          tr.querySelectorAll("th").forEach((th) => {
            th.classList.remove("table-b-table-default");
            th.classList.remove("b-table-sticky-column");

            th.className = th.className
              .split(" ")
              .sort()
              .reduce((total, item) => {
                return total + "-" + item;
              });

            if (th.style.display === "none") {
              th.remove();
            }
          });
        });

      temp
        .querySelectorAll("#tabel-dinamis-pivot-table > tbody > tr")
        .forEach((tr) => {
          tr.querySelectorAll("th").forEach((th) => {
            th.classList.remove("table-b-table-default");
            th.classList.remove("b-table-sticky-column");

            th.className = th.className
              .split(" ")
              .sort()
              .reduce((total, item) => {
                return total + "-" + item;
              });
          });

          tr.querySelectorAll("td").forEach((td) => {
            let classNames = td.className
              .split(" ")
              .filter((item) => item.startsWith("tabel-dinamis-"));
            td.className = classNames[classNames.length - 1];
          });
        });

      temp
        .querySelectorAll("#tabel-dinamis-pivot-table > tfoot > tr")
        .forEach((tr) => {
          tr.querySelectorAll("th").forEach((th) => {
            th.classList.remove("table-b-table-default");
            th.classList.remove("b-table-sticky-column");

            th.className = th.className
              .split(" ")
              .sort()
              .reduce((total, item) => {
                return total + "-" + item;
              });
          });

          tr.querySelectorAll("td").forEach((td) => {
            let classNames = td.className
              .split(" ")
              .filter((item) => item.startsWith("tabel-dinamis-"));
            td.className = classNames[classNames.length - 1];
          });
        });

      return temp.outerHTML;
    },
    constructExcelFile(data, sheetName) {
      let base64,
        ctx,
        // uri = "data:application/vnd.ms-excel;base64,",
        template =
          '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]-->' +
          this.excelStyle +
          '</head><body><table>{table}</table></body></html>"';

      ctx = { worksheet: sheetName || "Worxksheet", table: data };
      // base64 = uri + this.base64(this.format(template, ctx));
      base64 = this.base64(this.format(template, ctx));

      return base64;
    },
    base64ToArrayBuffer(base64) {
      // Decode base64
      const binaryString = atob(base64);
      const len = binaryString.length;
      const bytes = new Uint8Array(len);

      // Convert binary string to array buffer
      for (let i = 0; i < len; i++) {
        bytes[i] = binaryString.charCodeAt(i);
      }

      return bytes.buffer;
    },
    downloadExcel() {
      let dataExcel = this.generateDataSheet();
      // Misal contoh base64 file Excel
      const base64Data = this.constructExcelFile(dataExcel);

      // Convert base64 ke ArrayBuffer
      const arrayBuffer = this.base64ToArrayBuffer(base64Data);

      // Buat Blob dari ArrayBuffer dengan tipe file Excel
      const blob = new Blob([arrayBuffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      // Buat link download dan trigger
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = "file.xlsx";
      link.click();

      // Hapus link setelah download
      URL.revokeObjectURL(link.href);

      // // Ambil elemen tabel menggunakan ref
      // const table = this.$refs["dataTable"];

      // // Konversi tabel HTML menjadi workbook Excel
      // const workbook = XLSX.utils.table_to_book(table, { sheet: "Sheet1" });

      // // Buat file Excel dan download
      // XLSX.writeFile(workbook, "table_data.xlsx");
    },
    downloadCSV() {
      // Ambil elemen tabel
      const table = this.$refs["dataTable"];
      let csvContent = "";
      let rowData = [];

      for (let index = 0; index < this.fields.length; index++) {
        const element = this.fields[index];
        if (this.additionalFields != undefined) {
          const test = this.additionalFields[0].items.map((obj) =>
            element.key.includes(obj.key)
          );
          const finded = test.findIndex((x) => x == true);
          if (finded >= 0) {
            rowData.push(this.additionalFields[0].items[finded].label);
          } else {
            rowData.push("");
          }
        }
      }
      csvContent += rowData.join(",") + "\n";
      rowData = this.fields.map((x) => x.label);
      csvContent += rowData.join(",") + "\n";

      // Looping baris tabel
      for (let row of table.items) {
        rowData = [];

        // Looping setiap cell di dalam baris
        for (let field of this.fields) {
          rowData.push(row[field.key]);
        }

        // Gabungkan cell menjadi satu baris CSV
        csvContent += rowData.join(",") + "\n";
      }

      // Membuat Blob dari CSV content
      const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });

      // Membuat link download
      const link = document.createElement("a");
      const url = URL.createObjectURL(blob);
      link.setAttribute("href", url);
      link.setAttribute("download", this.title + ".csv");
      link.style.visibility = "hidden";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },

    async getDetailDataset(id) {
      this.isLoading = true;
      await mmsService.getDetailData(id).then(
        (result) => {
          Object.assign(this.$data, this.$options.data.apply(this));
          this.data = result.data.result[0].data.data;

          this.metadata = result.data.result[0].metadata[0];
          this.regionLevel = this.metadata.region_lowest_level;
          this.setHeaderTable(this.metadata);
          this.setData(this.data);
          this.prevSelectedRegionId = this.selectedRegionId;
          this.isLoading = false;
        },

        (error) => {
          this.getDetailDataset(this.$route.params.id);
          console.log(error);
        }
      );
    },
    async getDetailDatasetWithRegionFilter() {
      this.isLoading = true;
      await mmsService
        .getDetailDatasetWithRegionFilter(this.id, this.selectedRegionId)
        .then(
          (result) => {
            let regLevel = this.regionLevel;
            let prevSelectedRegion = this.filterRegions.filter(
              (x) => x.value == this.prevSelectedRegionId
            )[0];
            Object.assign(this.$data, this.$options.data.apply(this));
            this.regionLevel = regLevel;
            this.data = result.data.result[0].data.data;
            this.metadata = result.data.result[0].metadata[0];
            this.setHeaderTable(this.metadata);
            this.setData(this.data);
            this.filterRegions.unshift(prevSelectedRegion);
            this.prevSelectedRegionId = this.selectedRegionId;
            this.isLoading = false;
          },

          (error) => {
            console.log(error);
          }
        );
    },
    resetDataview() {
      this.getDetailDataset(this.id);
    },
    setData(data) {
      this.transformData = Object.keys(data).map(function (key) {
        return data[key];
      });
      let new_data = this.transformData;
      this.transformData2 = new_data.map((x) => {
        let result = {};
        let period = x.period;
        let indicatorId = x.indicator.indicatorId;
        //let regionId = x.region.itemCategoryId;

        let key = period + "-" + indicatorId;
        if (x.itemCategory1 && x.itemCategory1.itemCategoryId != 0) {
          if (this.row_dimensions.length > 0) {
            this.row_dimensions.map((dim, index) => {
              let dim_items = dim.items.map((x) => x.id);
              if (!dim_items.includes(x.itemCategory1.itemCategoryId)) {
                key = key + "-" + x.itemCategory1.itemCategoryId;
              } else {
                Object.assign(result, {
                  ["row_dimension_" + (index + 1)]:
                    x.itemCategory1.itemCategoryName,
                  row_dimension_code: x.itemCategory1.itemCategoryId,
                });
              }
            });
          } else {
            key = key + "-" + x.itemCategory1.itemCategoryId;
          }
        }

        if (x.itemCategory2 && x.itemCategory2.itemCategoryId != 0) {
          if (this.row_dimensions.length > 0) {
            this.row_dimensions.map((dim, index) => {
              let dim_items = dim.items.map((x) => x.id);
              if (!dim_items.includes(x.itemCategory2.itemCategoryId)) {
                key = key + "-" + x.itemCategory2.itemCategoryId;
              } else {
                Object.assign(result, {
                  ["row_dimension_" + (index + 1)]:
                    x.itemCategory2.itemCategoryName,
                  row_dimension_code: x.itemCategory2.itemCategoryId,
                });
              }
            });
          } else {
            key = key + "-" + x.itemCategory2.itemCategoryId;
          }
        }
        if (x.itemCategory3 && x.itemCategory3.itemCategoryId != 0) {
          if (this.row_dimensions.length > 0) {
            this.row_dimensions.map((dim, index) => {
              let dim_items = dim.items.map((x) => x.id);
              if (!dim_items.includes(x.itemCategory3.itemCategoryId)) {
                key = key + "-" + x.itemCategory3.itemCategoryId;
              } else {
                Object.assign(result, {
                  ["row_dimension_" + (index + 1)]:
                    x.itemCategory3.itemCategoryName,
                  row_dimension_code: x.itemCategory3.itemCategoryId,
                });
              }
            });
          } else {
            key = key + "-" + x.itemCategory3.itemCategoryId;
          }
        }
        if (x.itemCategory4 && x.itemCategory4.itemCategoryId != 0) {
          if (this.row_dimensions.length > 0) {
            this.row_dimensions.map((dim, index) => {
              let dim_items = dim.items.map((x) => x.id);
              if (!dim_items.includes(x.itemCategory4.itemCategoryId)) {
                key = key + "-" + x.itemCategory4.itemCategoryId;
              } else {
                Object.assign(result, {
                  ["row_dimension_" + (index + 1)]:
                    x.itemCategory4.itemCategoryName,
                  row_dimension_code: x.itemCategory4.itemCategoryId,
                });
              }
            });
          } else {
            key = key + "-" + x.itemCategory4.itemCategoryId;
          }
        }
        if (x.itemCategory5 && x.itemCategory5.itemCategoryId != 0) {
          if (this.row_dimensions.length > 0) {
            this.row_dimensions.map((dim, index) => {
              let dim_items = dim.items.map((x) => x.id);
              if (!dim_items.includes(x.itemCategory5.itemCategoryId)) {
                key = key + "-" + x.itemCategory5.itemCategoryId;
              } else {
                Object.assign(result, {
                  ["row_dimension_" + (index + 1)]:
                    x.itemCategory5.itemCategoryName,
                  row_dimension_code: x.itemCategory5.itemCategoryId,
                });
              }
            });
          } else {
            key = key + "-" + x.itemCategory5.itemCategoryId;
          }
        }
        //set row header : region, no problem if only parent exist
        if (
          x.region.itemCategoryName == this.parentRegion.name &&
          this.regions[0].items.length > 1
        ) {
          Object.assign(result, {
            id: key,
            region: x.region.itemCategoryName,
            is_parent: true,
            region_code: x.region.itemCategoryCode,
            value: x.value,
            [key]: Number(x.value).toLocaleString(),
          });
        } else {
          Object.assign(result, {
            id: key,
            region: x.region.itemCategoryName,
            is_parent: false,
            region_code: x.region.itemCategoryCode,
            value: x.value,
            [key]: Number(x.value).toLocaleString(),
          });
        }
        return result;
      });

      if (this.regions[0].items.length > 1) {
        this.transformData3 = this.transformData2.reduce(
          (accumulator, value) => {
            if (!accumulator[value.region]) {
              accumulator[value.region] = [];
            }
            accumulator[value.region].push(value);
            return accumulator;
          },
          {}
        );
      } else {
        let key = "";
        this.row_dimensions.forEach((dim, index) => {
          let keyname = "row_dimension_" + (index + 1);
          if (keyname in this.transformData2[0]) {
            key = keyname;
          }
        });
        this.transformData3 = this.transformData2.reduce(
          (accumulator, value) => {
            if (!accumulator[value[key]]) {
              accumulator[value[key]] = [];
            }

            accumulator[value[key]].push(value);
            return accumulator;
          },
          {}
        );
      }
      this.transformData4 = Object.values(this.transformData3).map((x) =>
        Object.assign({}, ...x, {
          sum: x.map((o) => o.value).reduce((a, c) => a + c),
        })
      );
      if (this.regions[0].items.length > 1) {
        this.transformData4 = lodash.orderBy(
          this.transformData4,
          "region_code",
          "asc"
        );
      } else {
        this.transformData4 = lodash.orderBy(
          this.transformData4,
          "row_dimension_code",
          "asc"
        );
      }

      // let maxObject = lodash.maxBy(this.transformData4, "sum");
      // this.transformData4 = this.transformData4.concat(
      //   this.transformData4.splice(this.transformData4.indexOf(maxObject), 1)
      // );
    },
    setHeaderTable(metadata) {
      this.id = metadata.id;
      this.title = metadata.name;
      this.subject_field = metadata.subject_field;
      this.dimensions = metadata.data_structure.filter(
        (x) => x.role != "Measure"
      );

      this.metadata = metadata;
      this.periods = metadata.dataset_period.map((x) => x.period);

      this.measures = metadata.data_structure.filter(
        (x) => x.role == "Measure"
      );
      this.measures = this.measures.map((measure) => ({
        ...measure,
        // items: metadata.dataset_measure.map((x) => x.statistical_indicator[0].id),
        items: metadata.dataset_measure
          .filter((x) => x.data_structure_id == measure.id)
          .map((x) => x.statistical_indicator[0].id),
      }));
      this.regions = metadata.data_structure.filter((x) => x.role == "Region");
      this.regions = this.regions.map((dim) => ({
        ...dim,
        items: metadata.dataset_dimension
          .filter((x) => x.data_structure_id == dim.id)[0]
          .dimension_classification_items.map(({ id, name, is_parent }) => ({
            id,
            name,
            is_parent,
          })),
      }));
      this.row_dimensions = metadata.data_structure
        .filter((x) => x.role == "Dimension" && x.header_type == "Row")
        .sort((a, b) => {
          Number(a.column_order) - Number(b.column_order);
        });

      this.row_dimensions = this.row_dimensions.map((dim) => ({
        ...dim,
        items: metadata.dataset_dimension
          .filter((x) => x.data_structure_id == dim.id)[0]
          .dimension_classification_items.map(
            ({ id, code, name, description }) => ({
              id,
              code,
              name,
              description,
            })
          ),
      }));
      this.col_dimensions = metadata.data_structure
        .filter((x) => x.role == "Dimension" && x.header_type == "Column")
        .sort((a, b) => {
          Number(a.column_order) - Number(b.column_order);
        });
      this.col_dimensions = this.col_dimensions.map((dim) => ({
        ...dim,
        items: metadata.dataset_dimension
          .filter((x) => x.data_structure_id == dim.id)[0]
          .dimension_classification_items.map(({ id, name, description }) => ({
            id,
            name,
            description,
          })),
      }));
      this.transformMeta = this.periods.map((period) => {
        let keys1 = [];
        let keys2 = [];

        this.measures.forEach((measure) => {
          measure.items.forEach((item) => {
            // keys1.push(period + "-" + item);
            let key = period + "-" + item;
            let label;
            if (this.periods.length > 1) {
              if (this.measures.length > 1) {
                label = measure.column_name;
              } else {
                label = period;
              }
            } else {
              label = measure.column_name;
            }
            keys1.push({ id: key, key: key, label: label });
          });
        });

        this.regions.forEach((region) => {
          region.items.forEach((item) => {
            keys1.forEach((key) => {
              //keys2.push({ id: key, region: item.id });
              keys2.push({
                id: key.id,
                key: key.key,
                label: key.label,
                region: item.id,
                tdClass: "text-right",
              });
            });
          });
        });
        if (this.col_dimensions.length > 0) {
          let keys3 = [];
          this.col_dimensions.forEach((dim, index) => {
            if (keys3.length == 0) {
              keys2.forEach((key) => {
                dim.items.forEach((item) => {
                  if (index == this.col_dimensions.length - 1) {
                    keys3.push({
                      id: key.id + "-" + item.id,
                      key: key.id + "-" + item.id,
                      region: key.region,
                      label: item.name,
                      tdClass: "text-right",
                    });
                  } else {
                    keys3.push({
                      id: key.id + "-" + item.id,
                      region: key.region,
                    });
                  }
                });
              });
            } else {
              let newKeys = [];
              keys3.forEach((key) => {
                dim.items.forEach((item) => {
                  if (index == this.col_dimensions.length - 1) {
                    newKeys.push({
                      id: key.id + "-" + item.id,
                      key: key.id + "-" + item.id,
                      region: key.region,
                      label: item.name,
                      tdClass: "text-right",
                    });
                  } else {
                    newKeys.push({
                      id: key.id + "-" + item.id,
                      region: key.region,
                    });
                  }
                });
              });
              keys3 = newKeys;
            }
          });
          return keys3;
        } else {
          return keys2;
        }
      });

      //Add Row Field "Region" For Table

      if (
        this.regions[0].items.length > 1 ||
        (this.regions[0].items.length == 1 && this.row_dimensions.length == 0)
      ) {
        this.transformMeta[0].unshift({
          id: "region",
          key: "region",
          label: this.regions[0].column_name,
          thClass: this.col_dimensions.length > 1 ? "row-header" : "",
          tdClass: "text-left text-nowrap ",
        });
      }
      //Add Row Field "Dimension" For Table
      if (this.row_dimensions.length > 0) {
        this.row_dimensions.map((dim, index) => {
          this.transformMeta[0].unshift({
            id: "row_dimension_" + (index + 1),
            key: "row_dimension_" + (index + 1),
            label: dim.column_name,
            thClass: this.col_dimensions.length > 1 ? "row-header" : "",
            tdClass: "text-center text-nowrap",
          });
        });
      }
      // if (this.regions[0].items.length == 1 && this.row_dimensions.length > 0) {
      //   this.row_dimensions.map((dim, index) => {
      //     this.transformMeta[0].unshift({
      //       key: "row_dimension_" + (index + 1),
      //       label: dim.column_name,
      //       thClass: this.col_dimensions.length > 1 ? "row-header":"",
      //       tdClass: "text-center text-nowrap",
      //     });
      //   });
      // }

      //this.fields = this.transformMeta[0];
      this.fields = this.transformMeta.flat();
      //contains duplicate field
      this.fields = this.fields.map((field) => ({
        ...field,
        class: "d-table-cell",
      }));
      //remove duplicate field
      this.fields = this.fields.reduce((accumulator, field) => {
        if (accumulator.filter((x) => x.id == field.id).length == 0) {
          accumulator.push(field);
        }
        return accumulator;
      }, []);

      this.col_number =
        this.col_dimensions.length > 0
          ? this.col_dimensions
              .map((x) => x.items.length)
              .reduce((a, b) => a * b)
          : 0;
      if (this.periods.length > 1 && this.col_dimensions.length > 0) {
        this.additionalFields.push({
          name: "periode",
          items: metadata.dataset_period.map((x) => ({
            id: x.period,
            key: x.period,
            label: x.period,
            description: x.name,
          })),
        });
        this.col_number =
          this.col_number == 0
            ? this.periods.length
            : this.col_number * this.periods.length;
      }
      //Berarti data masih 1 periode (cross sectional)
      if (this.additionalFields.length == 0) {
        this.additionalFields = this.col_dimensions.filter(
          (x, index) => index != this.col_dimensions.length - 1
        );
        this.additionalFields = this.additionalFields.map((x, index) => {
          if (index == 0) {
            return {
              name: x.column_name,
              items: x.items.map((item) => ({
                id: item.id.toString(),
                key: item.id.toString(),
                label: item.name,
                description: item.description,
              })),
            };
          } else {
            let result = [];
            this.additionalFields[index - 1].items.forEach((prev) => {
              let newItems = x.items.map((item) => {
                return {
                  id: prev.id + "-" + item.id,
                  key: prev.id + "-" + item.id,
                  label: item.name,
                  description: item.description,
                };
              });
              result.push(newItems);
            });
            return { name: x.column_name, items: result.flat() };
          }
        });
      } else {
        let merge = [];
        this.additionalFields.forEach((period) => {
          merge.push(period);
        });
        if (this.col_dimensions.length > 1) {
          this.col_dimensions
            .filter((x, index) => index != this.col_dimensions.length - 1)
            .forEach((dim) => {
              merge.push({
                name: dim.column_name,
                items: dim.items.map((item) => ({
                  id: item.id.toString(),
                  key: item.id.toString(),
                  label: item.name,
                  description: item.description,
                })),
              });
            });
        }

        this.additionalFields = merge;
        this.additionalFields = this.additionalFields.map((x, index) => {
          if (index == 0) {
            return {
              name: x.name,
              items: x.items.map((item) => ({
                id: item.id.toString(),
                key: item.id.toString(),
                label: item.label,
                description: item.description,
              })),
            };
          } else {
            let result = [];
            this.additionalFields[index - 1].items.forEach((prev) => {
              let newItems = x.items.map((item) => {
                return {
                  id: prev.id + "-" + item.id,
                  key: prev.id + "-" + item.id,
                  label: item.label,
                  description: item.description,
                };
              });
              result.push(newItems);
            });
            return { name: x.column_name, items: result.flat() };
          }
        });
      }
      this.regionDataStructureId = this.regions[0].id;
      this.filterRegions = this.regions[0].items.map((item) => ({
        value: item.id,
        text: item.name.toLowerCase(),
      }));
      // this.parentRegion = this.regions[0].items
      //   .filter((x) => x.is_parent == 1)
      //   .map(({ id, name }) => ({ id, name }))[0];
      // this.selectedRegionId = this.parentRegion.id;

      let parentRegionItems = this.regions[0].items.filter(
        (x) => x.is_parent == 1
      );
      this.parentRegion = parentRegionItems
        ? parentRegionItems.map(({ id, name }) => ({ id, name }))[0]
        : null;
      this.selectedRegionId = this.parentRegion ? this.parentRegion.id : null;
      // this.filterDimensions = this.col_dimensions.map((dim) => {
      //   return {
      //     name: dim.column_name,
      //     items: dim.items.map((item) => ({
      //       value: item.id.toString(),
      //       text: item.name,
      //     })),
      //   };
      // });
      if (this.periods.length > 1) {
        this.filterDimensions.push({
          name: "periode",
          items: metadata.dataset_period.map((x) => ({
            value: x.period,
            text: x.name,
          })),
        });
      }
      this.col_dimensions.forEach((dim) => {
        this.filterDimensions.push({
          name: dim.column_name,
          items: dim.items.map((item) => ({
            value: item.id.toString(),
            text: item.name,
          })),
        });
      });
      // Uncomment this if row filter is enable
      // console.log('this.row_dimensions.forEach')
      // this.row_dimensions.forEach((dim) => {
      //   this.filterDimensions.push({
      //     name: dim.column_name,
      //     items: dim.items.map((item) => ({
      //       value: item.id.toString(),
      //       text: item.name,
      //     })),
      //   });
      // });

      this.selectedDimensionItems = this.filterDimensions
        .map((dim) => dim.items.map((x) => x.value.toString()))
        .flat();
      // console.log(this.fields);
      // console.log(this.additionalFields[0]);
    },
    rowClass(item, type) {
      if (!item || type !== "row") return;
      if (item.is_parent === true && this.regions[0].items.length > 1) {
        return "row-parent";
      }
      if (item.row_dimension_1 === "Total" || item.row_dimension_2 === "Total")
        return "row-parent";
    },
  },
};
</script>

<style scoped>
.custom-checkbox .custom-control-input:checked ~ .custom-control-label::before {
  color: #fff;
  border-color: white !important;
  background-color: white !important;
}
</style>